<template>
    <div class="page-basicpop" @touchmove.prevent>
        <div class="pop-con">
            <div class="pop-tit" v-if="popTit">{{ popTit }}</div>
            <div class="pop-content" v-if="popContent">{{ popContent }}</div>
            <div class="pop-butn">
                <div class="left-butn" @click="leftButnClick">{{ leftButnText }}</div>
                <div class="right-butn" @click="rightButnClick">{{ rightButnText }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['popTit', 'popContent', 'leftButnText', 'rightButnText'],
    methods: {
        leftButnClick() {
            this.$emit('OnLeftButnClick');
        },
        rightButnClick() {
            this.$emit('OnRightButnClick');
        }
    }
};
</script>

<style lang="less" scoped>
.page-basicpop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .pop-con {
        width: 303px;
        background: #fff;
        border-radius: 8px;
        padding: 0 24px;
        .pop-tit {
            font-size: 18px;
            color: #002a3c;
            // font-family: fzlt_bold;
            font-weight: bold;
            text-align: center;
            margin-top: 30px;
        }
        .pop-content {
            color: #49596c;
            font-size: 15px;
            // font-family: fzlt;
            line-height: 22px;
            margin-top: 16px;
        }
        .pop-butn {
            margin-top: 30px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 16px;
            // font-family: fzlt_bold;
            font-weight: bold;
            text-align: center;
            line-height: 37px;
            .left-butn {
                width: 117px;
                height: 36px;
                border-radius: 8px;
                border: 1px solid #dce1e6;
                color: #616b78;
            }
            .right-butn {
                width: 117px;
                height: 36px;
                background: linear-gradient(270deg, #3ca5e2 0%, #4dbaf9 100%);
                border-radius: 8px;
                color: #fff;
            }
        }
    }
}
</style>